/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs */

const en_admin_allocation_form_plan_info_is_on_plan = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is on plan`)
};

const de_admin_allocation_form_plan_info_is_on_plan = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`befindet sich auf Tarif`)
};

const es_admin_allocation_form_plan_info_is_on_plan = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiene el plan`)
};

const fr_admin_allocation_form_plan_info_is_on_plan = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`est inclus dans le plan`)
};

const nl_admin_allocation_form_plan_info_is_on_plan = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`heeft abonnement`)
};

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */
const it_admin_allocation_form_plan_info_is_on_plan = en_admin_allocation_form_plan_info_is_on_plan;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_plan_info_is_on_plan = en_admin_allocation_form_plan_info_is_on_plan;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */
const pl_admin_allocation_form_plan_info_is_on_plan = en_admin_allocation_form_plan_info_is_on_plan;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */
const hu_admin_allocation_form_plan_info_is_on_plan = en_admin_allocation_form_plan_info_is_on_plan;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs) => LocalizedString} */
const ro_admin_allocation_form_plan_info_is_on_plan = en_admin_allocation_form_plan_info_is_on_plan;

/**
* | output |
* | --- |
* | "is on plan" |
*
* @param {Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_plan_info_is_on_plan = /** @type {((inputs?: Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Plan_Info_Is_On_PlanInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "de") return de_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "es") return es_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "fr") return fr_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "nl") return nl_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "it") return it_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "pl") return pl_admin_allocation_form_plan_info_is_on_plan(inputs)
	if (locale === "hu") return hu_admin_allocation_form_plan_info_is_on_plan(inputs)
	return ro_admin_allocation_form_plan_info_is_on_plan(inputs)
});
export { admin_allocation_form_plan_info_is_on_plan as "admin.allocation_form.plan_info_is_on_plan" }